<template>
    <div class="bundle-wrap">
        <div class="model-wrap">
            <template v-for="(model, index) in bundle.models">
                <div v-if="index > 0" class="model-separator">+</div>
                <a class="model-block" :href="model.url" target="_blank">
                    <img class="model-img" :src="model.preview" />
                    <div class="model-name" :title="model.name">
                        {{ model.name }}
                    </div>
                </a>
            </template>
        </div>
        <div class="price-wrap">
            <div class="price-title">Bundle price</div>
            <div class="price-cur">${{ calcBundleSalePrice() }}</div>
            <div class="price-old">${{ calcBundlePrice() }}</div>
            <div class="price-save">You save {{ bundle.discount * 100 }}%</div>
            <button type="button" class="price-btn" :disabled="stored || !isReady" @click="addToCard">
                {{loading ? "ADDING..." : "ADD TO CART"}}
            </button>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: ["bundle"],
    data() {
        return {
            loading: false,
            stored: false,
            isReady: false,
        }
    },
    created() {
        const interval = setInterval(() => {
            if (window.Alpine) {
                this.isReady = true;
                clearInterval(interval);
            }
        }, 2000);
    },
    methods: {
        calcBundlePrice() {
            let sum = 0;
            this.bundle.models.forEach((model) => {
                if (model.default_price) sum += Number(model.default_price);
            });
            return sum.toFixed(2);
        },
        calcBundleSalePrice() {
            const price = this.calcBundlePrice();
            const sale = this.bundle.discount * price;
            const oldPrice = price - sale;
            return oldPrice.toFixed(2);
        },
        async addToCard() {
            if (this.loading) return;

            this.loading = true;
            const itemIds = this.bundle.models.map((model) => model.id);
            let result;

            for (const id of itemIds) {
                result = await axios.post(
                    "/cart/add",
                    { item: id },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                            'X-CSRF-TOKEN': window.Alpine.store('app').token,
                        },
                    },
                );
            }

            if (result.status >= 200 && result.status < 300) {
                this.loading = false;

                window.Alpine.store('cart').cartData = result.data.cart;
                window.Alpine.store('cart').shopType = 'premium';
                window.Alpine.store('cart').openCart = true;

                safeStorage.set('modelsInGeCart', result.data.cart.count);
            }

            if (result.status >= 200 && result.status < 300 && result.data?.cart_markup) {
                this.loading = false;
                this.stored = true;

                const cart = document.getElementById("cart-container");
                if (cart) cart.innerHTML = result.data.cart_markup;
                const popup = document.querySelector("#cart-container .popupPrt");
                if (popup) {
                    popup.style.display = "block";
                    setTimeout(() => popup.removeAttribute("style"), 3000);
                }
                this.bundle.models.map((model) => window.GE.callbacks.addedToCart({id:model.id,name:model.name, price:model.price, category: null}, 'bundles'));
            }

            if (result.status === 400) {
                window.location.href = "/auth/signin";
            }
        },
    },
};
</script>

<style scoped>
.bundle-wrap {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
    padding: 18px;
    background-color: #fff;
    border: 1px solid #f2f2f2;
    border-radius: 4px;
}
.model-wrap {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: flex-start;
}
.model-separator {
    padding-top: 34px;
    color: #101010;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: 0.25px;
}
.model-block {
    display: flex;
    gap: 8px;
    flex-direction: column;
}
.model-img {
    width: 110px;
    height: 110px;
    object-fit: cover;
    border-radius: 4px;
}
.model-name {
    display: -webkit-box;
    width: 110px;
    max-height: 54px;
    color: #666666;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: normal;
    word-wrap: break-word;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.price-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-width: 110px;
    width: 110px;
    color: #000;
    font-size: 14px;
    line-height: 28px;
}
.price-title {
    font-weight: 500;
}
.price-cur {
    color: #d93636;
    font-size: 22px;
    line-height: 34px;
}
.price-old {
    color: #808080;
    text-decoration: line-through;
}
.price-save {
    margin-bottom: 26px;
    color: #4bb13c;
    font-weight: 500;
}
.price-btn {
    width: 100%;
    padding: 6px;
    font-weight: 500;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 1.2px;
    text-align: center;
    background-color: #fff;
    border: 1px solid #304ffe;
    border-radius: 4px;
    cursor: pointer;
}
.price-btn:disabled {
    color: #808080;
    border-color: #808080;
    cursor: not-allowed;
}
</style>
